export default "__VITE_ASSET__BDlQpMFP__"